import { VFC } from "react";
import { Box, Button, Card, Container, Divider, Grid, TableHead, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TenantDetailResponse } from "../../tenant/api/TenantForm";
import { Utility } from "../../../utils/Utility";

type Props = {
  tenant: TenantDetailResponse;
};
const TenantDetailView: VFC<Props> = ({ tenant: tenant }) => {

  const CELL_WIDTH = 3;

  const style = {
    gridWrap: {
      fontSize: "0.875rem",
      mb: 2,
      "& > div": {
        p: 1,
      },
      "& > div:not(:nth-of-type(4n))": {
        borderRight: "1px solid #eaeded",
      },
      "& div div:nth-of-type(1)": {
        color: "#545b64",
      },
      "& div div:nth-of-type(2)": {
        color: "#16191f",
        fontWeight: "bold",
      },
    },
  };

  return (
    <Box sx={{ 
      p: 1, 
      // border: 1 
    }}>
      <Box display={"flex"} flexWrap={"wrap"} sx={style.gridWrap}>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナントID</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.id)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナントコード</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.disclosureCode)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナント名</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.tenantName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>企業名</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.companyName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>親テナント名</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.parentName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>上位からの操作</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.upperOperation)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>基本情報</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.basicInformation)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>管理者名</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.administratorName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>責任者名</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.responsibleName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>営業担当者名</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.salesRepresentativeName)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナントステータス</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.tenantStatus)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナント開設料</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.contractChargePrice)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>テナント契約期間</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(tenant.contractStart))}~{Utility.NullEmptyStringWrap(Utility.dateFormat(tenant.contractEnd))}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>MDMアカウント登録上限</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.contractMaxAccount)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>MFA認証実施可否</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.isMfaauth)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>契約条件（前払い必須）</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.isMaebarai)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>備考</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.comment)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>作成者</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.createUser)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>作成日時</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(tenant.createDate))}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>更新者</Box>
        <Box>{Utility.NullEmptyStringWrap(tenant.updateUser)}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>更新日時</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(tenant.updateDate))}</Box>
      </Grid>
      <Grid item xs={CELL_WIDTH}>
        <Box>削除日時</Box>
        <Box>{Utility.NullEmptyStringWrap(Utility.dateFormat(tenant.deleteDate))}</Box>
      </Grid>
      </Box>
    </Box>
  );
};

export default TenantDetailView;
